export default "__VITE_ASSET__D$CRFKk___"